import type { Rule } from './rule'

export type LogicalOperator = '&&' | '||'

export class LogicalOperatorRule implements Rule {
  constructor(private rule1: Rule, private rule2: Rule, private operator: LogicalOperator) {}

  public isValid(): boolean {
    return this.operator === '&&'
      ? this.rule1.isValid() && this.rule2.isValid()
      : this.rule1.isValid() || this.rule2.isValid()
  }
}
